export default {
  conf: {
    wechatCode: 'wechat Code',
    wechatName: 'wechat Name',
    appId: 'appId',
    appSecret: 'app Secret',
    Token: 'Token',
    encodeAesKey: 'encode Aes Key',
    messageEncrypt: 'message Encrypt',
    accessToken: 'access Token',
    JSAPITICKET: 'JSAPITICKET',
    domain: 'domain',
    refreshTime: 'refresh Time',
    mchId: 'mchId',
    payKey: 'payKey',
    certificatePath: 'certificate Path',
    certificateKey: 'certificate Key',
    showUrlConf: 'show Url Conf'
  }

}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/wechat/conf.js